import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { CalculatorFlow } from './pages/CalculatorFlow';
import { ResultsPage } from './pages/ResultsPage';
import { PreviewEditor } from './pages/PreviewEditor';
function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/calculator" element={<CalculatorFlow data-id="element-5" />} data-id="element-4" />
        <Route path="/results" element={<ResultsPage data-id="element-7" />} data-id="element-6" />
        <Route path="/preview" element={<PreviewEditor data-id="element-9" />} data-id="element-8" />
        {/* Redirect old route to new landing */}
        <Route path="*" element={<Navigate to="/" replace data-id="element-11" />} data-id="element-10" />
      </Routes>
    </BrowserRouter>;
}
export { App };